import type { FC } from "react";
import { useEffect, useState } from "react";

import { Checkbox } from "@jti/core-components/components/Checkbox";
import { IOrderDataTypeEnum, type OrderAttribute } from "@jti/magento";
import { FormField, useFormContext, useTranslations } from "@jti/ui";

import { FormFields } from "@checkout/constants/checkout-constants";

import styles from "./OrderAttributeCheckbox.module.scss";

type OrderAttributeProps = {
  orderAttribute: OrderAttribute;
};

export const OrderAttributeCheckbox: FC<OrderAttributeProps> = ({ orderAttribute }) => {
  const { __ } = useTranslations();
  const { setValue } = useFormContext();
  const [rawValue, setRawValue] = useState(false);

  const id = `${FormFields.OrderAttributes}-${orderAttribute.code}`;
  const name = `${FormFields.OrderAttributes}.${orderAttribute.code}`;

  useEffect(() => {
    const convertValue = (value: boolean): string => {
      if (orderAttribute.data_type === IOrderDataTypeEnum.Int) {
        return value ? "1" : "0";
      }
      return value ? "true" : "false";
    };

    setValue(name, convertValue(rawValue));
  }, [rawValue]);

  return (
    <>
      <FormField
        id={orderAttribute.code}
        name={name}
        defaultValue={false}
        className={styles.checkoutLabel}
        render={({ field }) => (
          <Checkbox
            {...field}
            checked={rawValue}
            onCheckedChange={(checked) => {
              setRawValue(checked);
            }}
            id={id}
            data-testid={id}
            label={`${orderAttribute.is_required ? "* " : ""}${orderAttribute.label}`}
          />
        )}
        checkable
        validation={{
          ...(orderAttribute.is_required && {
            required: {
              value: orderAttribute.is_required,
              message: __("form_validation.field_required"),
            },
          }),
        }}
      />
    </>
  );
};
